<div class="users-page-container">
    <!-- Page Header -->
    <div class="page-header">
        <div class="header-left">
            <div class="header-title">
                <h1>Users</h1>
                <p>Total Users: {{ totalUsers }}</p>
            </div>
        </div>
    </div>

    <!-- Search Bar -->
    <div class="search-section" *ngIf="isUsers">
        <div class="search-container">
            <div class="search-controls">
                <form class="search-block" (submit)="onSearchSubmit()">
                    <div class="search-input">
                        <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by full name, Username">
                    </div>
                    <button type="submit" class="icon-btn">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                        </svg>
                    </button>
                </form>
                                   <button type="button" class="reset-btn" (click)="reset($event)">
                       Reset
                   </button>
            </div>
            <div class="action-buttons">
                <button class="add-user-btn" (click)="addUserDialog()">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 1.33333V14.6667M1.33333 8H14.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Add User
                </button>
            </div>
        </div>
    </div>

    <!-- Users Table -->
    <div class="table-container" *ngIf="isUsers">

        <div class="table-wrapper">
            <table class="users-table">
                <thead>
                    <tr>
                        <th scope="col">Full Name</th>
                        <th scope="col">Username</th>
                        <th scope="col">Contact number</th>
                        <th scope="col">Email</th>
                        <th scope="col">
                            Role
                            <span class="filter-trigger" id="status-popup--trigger" (click)="openRolesPopup($event)">
                                <svg *ngIf="selectedRoles.length === 0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <svg *ngIf="selectedRoles.length !== 0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 6L4.5 8.5L10 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <div class="popup" id="roles-popup">
                                <form>
                                    <div class="form-group" *ngFor="let role of roleList">
                                      <input name="role" [id]="role.name" type="checkbox" [value]="role.id" [checked]="selectedRoles.includes(role.id.toString()) ? true : false" (change)="onRolesFilterChange($event)">
                                      <label class="text-capitalize" [for]="role.name">{{ role.name }}</label>
                                    </div>
                                </form>
                            </div>
                        </th>
                        <th scope="col">
                            Added Date
                            <span class="sort-trigger" (click)="createdAtSort()">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 4.5L6 1.5L9 4.5M3 7.5L6 10.5L9 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody *ngIf="isFilterResult">
                    <tr *ngFor="let user of usersList" (dblclick)="viewUserDialog(user.user_id)">
                        <td class="user-name">{{ user.first_name + " " + user.last_name }}</td>
                        <td class="username">{{ user.username }}</td>
                        <td class="contact">{{ user.contact_number ? user.contact_number : '-' }}</td>
                        <td class="email">{{ user.email }}</td>
                        <td class="role-cell">
                            <span class="role-badge">{{user.roles[0].name.trim()}}</span>
                            <span class="warning-icon" *ngIf="user.roles[0].is_hardware_permission && !user.is_user_has_stores" (click)="storesMissingPopover($event)">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="12" r="1" fill="#F59E0B"/>
                                    <path d="M8 8V4M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="#F59E0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <div class="popup stores-missing-popover" id="stores-missing-popover">
                                <p class="text-para text-dark">This User is not allocated with any store at this moment</p>
                            </div> 
                        </td>
                        <td class="date">{{ timestampFormat(user.created_at, "DD/MM/YYYY") }}</td>
                        <td class="actions-cell" (click)="openDotPopup($event)">
                            <svg class="actions-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="2" r="1.5" fill="currentColor"/>
                                <circle cx="8" cy="8" r="1.5" fill="currentColor"/>
                                <circle cx="8" cy="14" r="1.5" fill="currentColor"/>
                            </svg>
                            <div id="dots-popup" class="dots-popup">
                                <ul>
                                    <li (click)="editUserDialog(user.user_id)">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.75 1.75L12.25 5.25M1.75 12.25L5.25 8.75L8.75 12.25M1.75 12.25H4.25L8.75 7.75M1.75 12.25L5.25 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Edit User
                                    </li>
                                    <li (click)="updatePasswordDialog(user.user_id, user.first_name + ' ' + user.last_name)">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 1.75C5.20507 1.75 3.75 3.20507 3.75 5V6.25H2.5C1.80964 6.25 1.25 6.80964 1.25 7.5V11.5C1.25 12.1904 1.80964 12.75 2.5 12.75H11.5C12.1904 12.75 12.75 12.1904 12.75 11.5V7.5C12.75 6.80964 12.1904 6.25 11.5 6.25H10.25V5C10.25 3.20507 8.79493 1.75 7 1.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Update Password
                                    </li>
                                    <li (click)="deleteUserDialog(user.user_id, user.first_name + ' ' + user.last_name)" class="danger">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.75 3.5H12.25M4.375 3.5V2.625C4.375 2.27982 4.65482 2 5 2H9C9.34518 2 9.625 2.27982 9.625 2.625V3.5M5.25 6.125V9.625M8.75 6.125V9.625M2.625 3.5V11.375C2.625 11.7202 2.90482 12 3.25 12H10.75C11.0952 12 11.375 11.7202 11.375 11.375V3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Delete User
                                    </li>
                                </ul>
                            </div> 
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!isFilterResult">
                    <tr>
                        <td colspan="7" class="empty-state">
                            <div class="empty-content">
                                <svg class="empty-icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="32" cy="32" r="32" fill="#F3F4F6"/>
                                    <path d="M32 16C36.4183 16 40 19.5817 40 24C40 28.4183 36.4183 32 32 32C27.5817 32 24 28.4183 24 24C24 19.5817 27.5817 16 32 16Z" fill="#9CA3AF"/>
                                    <path d="M32 36C24.268 36 18 42.268 18 50H46C46 42.268 39.732 36 32 36Z" fill="#9CA3AF"/>
                                </svg>
                                <h3 class="empty-title">No users found</h3>
                                <p class="empty-description">No records were found matching your search criteria.</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="pagination-container" *ngIf="totalPages > 1 && isUsers">
            <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
        </div>
    </div>

    <!-- No Users State -->
    <div class="no-users-state" *ngIf="!isUsers">
        <div class="no-users-content">
            <svg class="no-users-icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="40" fill="#F3F4F6"/>
                <path d="M40 20C45.5228 20 50 24.4772 50 30C50 35.5228 45.5228 40 40 40C34.4772 40 30 35.5228 30 30C30 24.4772 34.4772 20 40 20Z" fill="#9CA3AF"/>
                <path d="M40 45C30.335 45 22.5 52.835 22.5 62.5H57.5C57.5 52.835 49.665 45 40 45Z" fill="#9CA3AF"/>
            </svg>
            <h2 class="no-users-title">No users available</h2>
            <p class="no-users-description">There are no users in the system yet. Create your first user to get started.</p>
            <button class="create-first-user-btn" (click)="addUserDialog()">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1.33333V14.6667M1.33333 8H14.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Create First User
            </button>
        </div>
    </div>

    <app-toast-message></app-toast-message>
</div>


